export const cleanFileName = (fileName: string) => {
  return fileName.replace(/[<>:'"\+\[\]\/\\|?$*%!#]+/g, '');
};
